import React from 'react'
import { Link } from 'react-router-dom'

export default function TopSection({data}) {
  return (
    <div className='top-section-cont'>
        <div className='column'>
        <img className='top-section-logo' src="https://tuquejasuma.com/media/images/entity103476_square.png" alt="" />

        <p className='top-section-text'><b>mucho +</b> que una revista</p>
        </div>
        {data && (
<>
<img className='top-section-img' src={data.img} alt="" />
        <div className='column gap1rem'>
        <p className='top-section-nm marginzero'> {data.number} </p>
        <p className='marginzero'> {data.edition} </p>
        <p className='redtext marginzero'> {data.hashtag} </p>
        <Link to="/article/gZG4OYADsvRAJ3mv1Ste"  className='redbgtext marginzero'> {data.button} </Link> 
        </div>
</>
        )}

      
 
    </div>
  )
}
